import { Component, Input, OnInit } from '@angular/core';
import { Page } from '../../../../models/page';
import { SearchResult } from '../../../../models/search-result';
import { ApplicationStateService } from '../../../../services/application-state.service';
import { SidebarService } from '../../../../services/sidebar.service';
import { SearchComponent } from '../../../sidebar/search/search.component';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'search-result-rect',
    templateUrl: './search-result-rect.component.html',
    styleUrls: ['./search-result-rect.component.scss'],
    standalone: true,
    imports: [
        NgStyle
    ]
})
export class SearchResultRectComponent implements OnInit {

    @Input() searchResult: SearchResult;
    @Input() page: Page;
    show: boolean;

    constructor(private applicationStateService: ApplicationStateService,
                private sidebarService: SidebarService) {

        this.sidebarService.sidebarEventFired$.subscribe(event => {
            this.show = event.component === SearchComponent;
        });
    }

    ngOnInit(): void {
        this.show = true;
        this.searchResult.position.h = this.getHeight();
        this.searchResult.position.w = this.getWidth();
        this.searchResult.position.x = this.getX();
        this.searchResult.position.y = this.getY();
    }

    /**
     * get height of position
     *
     * @returns {number}
     */
    getHeight(): number {
        return Math.min(this.searchResult.position.h, 100);
    }

    /**
     * get width of position
     *
     * @returns {number}
     */
    getWidth(): number {
        return Math.min(this.searchResult.position.w, 100);
    }

    /**
     * get x of position
     *
     * @returns {number}
     */
    getX(): number {
        return Math.min(this.searchResult.position.x, 100);
    }

    /**
     * get y of position
     *
     * @returns {number}
     */
    getY(): number {
        return Math.min(this.searchResult.position.y, 100);
    }

    /**
     * should this result be visible?
     *
     * @returns {boolean}
     */
    isVisible(): boolean {
        if (this.applicationStateService.isMobileMode()) {
            return true;
        }

        return !this.applicationStateService.isSidebarHidden && this.show;
    }
}
